import { StatusCodes } from 'http-status-codes';

export * from './fetch';
export * from './versioned';
export * from './request';
export * from './response';

export const CLIENT_NOT_SUPPORTED = 470;
export const QUOTA_EXCEEDED = 471;
export const ORGANIZATION_SUSPENDED = 472;
export const HAS_NO_ACTIVE_SUBSCRIPTION = 473;
export const SUBSCRIPTION_INCOMPLETE = 474; // TODO: This should be past due
export const FREE_SUBSCRIPTION_BLOCKED = 475;
export const SUBSCRIPTION_PAST_DUE = 480;
export const SESSION_LIMIT_OR_UNAUTHORIZED = 401;
export const AI_CREDITS_EXHAUSTED = 476;

const permanentErrors = [
  CLIENT_NOT_SUPPORTED,
  QUOTA_EXCEEDED,
  StatusCodes.FORBIDDEN,
  ORGANIZATION_SUSPENDED,
];

export const isPermanentError = (code: number) => permanentErrors.includes(code);
